import React, { useMemo } from "react";
import { Row, Col, Card, Statistic, Space } from "antd";
import { 
  FileTextOutlined, 
  CheckCircleOutlined, 
  CloseCircleOutlined,
  RiseOutlined 
} from "@ant-design/icons";

const StatsCards = ({ logs }) => {
  const stats = useMemo(() => {
    const total = logs.length;
    const success = logs.filter(l => String(l.status_code).startsWith("2")).length;
    const errors = logs.filter(l => String(l.status_code).startsWith("4") || String(l.status_code).startsWith("5")).length;
    const successRate = total ? Math.round((success / total) * 100) : 0;

    return { total, success, errors, successRate };
  }, [logs]);

  const cardStyle = {
    borderRadius: 12,
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
    height: "100%"
  };

  return (
    <Row gutter={16}>
      <Col xs={24} sm={12} lg={6}>
        <Card bordered={false} style={cardStyle}>
          <Statistic
            title={<span style={{ color: "#6b7280" }}>Total Logs</span>}
            value={stats.total}
            prefix={<FileTextOutlined style={{ color: "#1890ff" }} />}
            valueStyle={{ color: "#1f2937", fontWeight: 600 }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card bordered={false} style={cardStyle}>
          <Statistic
            title={<span style={{ color: "#6b7280" }}>Success Rate</span>}
            value={stats.successRate}
            suffix="%"
            prefix={<RiseOutlined style={{ color: "#52c41a" }} />}
            valueStyle={{ color: "#52c41a", fontWeight: 600 }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card bordered={false} style={cardStyle}>
          <Statistic
            title={<span style={{ color: "#6b7280" }}>Successful</span>}
            value={stats.success}
            prefix={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
            valueStyle={{ color: "#1f2937", fontWeight: 600 }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card bordered={false} style={cardStyle}>
          <Statistic
            title={<span style={{ color: "#6b7280" }}>Errors</span>}
            value={stats.errors}
            prefix={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
            valueStyle={{ color: "#ff4d4f", fontWeight: 600 }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default StatsCards;